import * as React from 'react';
import Fancybox from './fancybox';
import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import SwipeableViews from 'react-swipeable-views';
import { useTheme} from '@mui/material/styles';
import  AppBar from '@mui/material/AppBar';
import  Tabs  from '@mui/material/Tabs';
import  Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import './projects.scss';

// Function TabsPanel
function TabPanel(props){
    const { children, value, index, ...other} = props;

    return(
      <div 
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab${index}`}
        {...other}
        >
        {value === index && (
          <Box sx={{ p: 3}}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }
  TabPanel.propTypes ={
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function allyProps(index){
    return{
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

  export default function Projetos(){

    // Variables TabPanel
      const theme = useTheme();
      const [value, setValue] = React.useState(0);
      const handleChange = (event, newValue) =>{
        setValue(newValue);
      }
      const handleChangeIndex = (index) =>{
        setValue(index);
      }

    return(
        <>
          <div>
            <section id="project-section">
            <Container maxWidth='lg'>
              <h3
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0"
              >
                Soluções para o seu projeto 
              </h3>
              <h6
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0"
              >
              Fornecemos uma ampla gama de serviços de alta qualidade, para garantir o sucesso do seu empreendimento.
              </h6>
              <Box sx={{width: '100%', height: 'auto'}}>
                <AppBar position='static' color='default' className='appbar'>
                  <Tabs
                    className="tabs"
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="inherit"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                    centered={true}
                    data-aos="fade-in"
                    data-aos-duration="1000"
                  >
                    <Tab className='tab' label="Engenharia Civil" {...allyProps(0)} />
                    <Tab className='tab' label="Topografia" {...allyProps(1)} />
                    <Tab className='tab' label="Apoio Geologico" {...allyProps(2)} />
                    <Tab className='tab'label="Manutenção/Mecânica" {...allyProps(4)} />
                    <Tab className='tab' label="Facilities" {...allyProps(3)} />
                    <Tab className='tab' label="Armazém/Ferramentaria" {...allyProps(5)} />
                  </Tabs>
                </AppBar>
                <SwipeableViews
                  axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                  index={value}
                  onChangeIndex={handleChangeIndex}
                >
                  <TabPanel className="fancyimg" value={value} index={0} >
                    <Fancybox>
                      <p className="img-fancy flex flex-wrap">
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/engenharia/1024x768/1.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/engenharia/300x320/1.jpg" className='img-fluid'
                            data-aos="fade-zoom-in" 
                            data-aos-duration="1000"
                            data-aos-delay="300"
                            data-aos-offse="0"
                        />
                        </a>
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/engenharia/1024x768/5.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/engenharia/300x320/2.jpg" className='img-fluid'
                          data-aos="fade-zoom-in" 
                          data-aos-duration="1000"
                          data-aos-delay="300"
                          data-aos-offse="0"
                          />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/engenharia/1024x768/3.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/engenharia/300x320/3.jpg" className='img-fluid'
                            data-aos="fade-zoom-in" 
                            data-aos-duration="1000"
                            data-aos-delay="300"
                            data-aos-offse="0"
                          />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/engenharia/1024x768/4.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/engenharia/300x320/4.jpg" className='img-fluid'
                            data-aos="fade-zoom-in" 
                            data-aos-duration="1000"
                            data-aos-delay="300"
                            data-aos-offse="0"
                          />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/engenharia/1024x768/6.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/engenharia/300x320/5.jpg" className='img-fluid'
                            data-aos="fade-zoom-in" 
                            data-aos-duration="1000"
                            data-aos-delay="300"
                            data-aos-offse="0"
                          />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/engenharia/foto-2.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/engenharia/foto-1.jpg" className='img-fluid'
                            data-aos="fade-zoom-in" 
                            data-aos-duration="1000"
                            data-aos-delay="300"
                            data-aos-offse="0"
                          />
                        </a>
                      </p>
                    </Fancybox>
                  </TabPanel>
                  <TabPanel className="fancyimg" value={value} index={1} dir={theme.direction} >
                    <Fancybox>
                      <p className="img-fancy flex flex-wrap">
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/topografia/1024x768/1.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/topografia/330x350/1.jpg" />
                        </a>

                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/topografia/1024x768/2.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/topografia/330x350/2.jpg" />
                        </a>

                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/topografia/1024x768/3.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/topografia/330x350/3.jpg" />
                        </a>

                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/topografia/1024x768/4.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/topografia/330x350/4.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/topografia/1024x768/5.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/topografia/330x350/5.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/topografia/1024x768/6.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/topografia/330x350/6.jpg" />
                        </a>
                      </p>
                    </Fancybox>
                  </TabPanel>
                  <TabPanel className="fancyimg" value={value} index={2} dir={theme.direction} >
                    <Fancybox>
                      <p className="img-fancy flex flex-wrap">
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/geologia/300x320/1.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/geologia/300x320/1.jpg" />
                        </a>
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/geologia/1024x768/2.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/geologia/300x320/2.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/geologia/1024x768/3.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/geologia/300x320/3.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/geologia/300x320/4.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/geologia/300x320/4.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/geologia/300x320/5.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/geologia/300x320/5.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/geologia/1024x768/6.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/geologia/300x320/6.jpg" />
                        </a>
                      </p>
                    </Fancybox>
                  </TabPanel>
                  <TabPanel className="fancyimg" value={value} index={3} dir={theme.direction} >
                    <Fancybox>
                      <p className="img-fancy flex flex-wrap">
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/facilities/1024x768/1.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/facilities/300x320/1.jpg" />
                        </a>
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/facilities/1024x768/2.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/facilities/300x320/2.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/facilities/1024x768/3.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/facilities/300x320/3.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/facilities/1024x768/3.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/facilities/300x320/3.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/facilities/1024x768/5.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/facilities/300x320/5.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/ccp/1024x768/6.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/ccp/330x350/6.jpg" />
                        </a>
                      </p>
                    </Fancybox>
                  </TabPanel>
                  <TabPanel className="fancyimg" value={value} index={4} dir={theme.direction} >
                    <Fancybox>
                      <p className="img-fancy flex flex-wrap">
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/meio_ambiente/1024x768/1.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/meio_ambiente/300x320/1.jpg" />
                        </a>
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/meio_ambiente/1024x768/2.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/meio_ambiente/300x320/2.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/meio_ambiente/1024x768/3.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/meio_ambiente/300x320/3.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/meio_ambiente/1024x768/4.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/meio_ambiente/300x320/4.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/meio_ambiente/1024x768/5.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/meio_ambiente/300x320/5.jpg" />
                        </a>
              
                        <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/meio_ambiente/1024x768/6.jpg">
                          <img alt="" src="https://gruposeculos.com.br/files/meio_ambiente/300x320/6.jpg" />
                        </a>
                      </p>
                    </Fancybox>
                  </TabPanel>
                </SwipeableViews>
              </Box>
            </Container>
            </section>
              
          </div>
        </>
    )
}

